module.exports = __webpack_public_path__ + "assets/img/btn-view-f5a5fce0.png";